import {Component, OnInit} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap";
import {ApiService, VendorDebtRecord, Vendor, VOC, VOCType, VOCDebtRecordDTO, BankingService} from "../../../../../projects/accounting/src/public_api";
import {DatePipe, DecimalPipe} from "@angular/common";
import {MassTransferEditorComponent} from "./mass-transfer-editor/mass-transfer-editor.component";
import {DetailsViewerComponent} from './details-viewer/details-viewer.component';
import {PaymentEditorComponent, PaymentEditorType} from '../../popups/payment-editor/payment-editor.component';
import {VOCEditorComponent} from '../../popups/voc-editor/voc-editor.component';
import { CachingService } from '../../../../../projects/jv-common/src/lib/services/caching.service';
import { MessageBoxComponent, MessageBoxData } from '../../../../../projects/jv-ui/src/public_api';
import { DepositsEditorComponent } from './deposits-editor/deposits-editor.component';
import { MassTransferResolverComponent } from './mass-transfer-resolver/mass-transfer-resolver.component';

@Component({
  selector: 'app-debts-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss']
})
export class VendorsComponent implements OnInit {

  modalRef: BsModalRef;

  constructor(
    private modal: BsModalService,
    private api: ApiService,
    private cache: CachingService,
    private decimal: DecimalPipe,
    private date: DatePipe,
    private banking: BankingService) {
  }

  public dtConfig = null;
  public loading = false;
  period = null;
  currentPeriod = null;
  nextPeriod = null;
  private VENDOR_SUB_ACCOUNTS_CACHE_KEY: string = "vendor-sub-accounts";
  private VENDOR_PAYMENT_HISTORY_CACHE_KEY: string = "vendor-payment-history";

  subs: any = {};
  history: any = {};

  private generate(data: Array<VendorDebtRecord>, period) {
    if (this.nextPeriod == period) {
      return {
        data: data,

        group: i => {

          let parts = i.info.address.split(',');

          if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

          return { parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim() }
        },

        txt: i => [i.info.name, i.info.address, i.accounts[0].owner, i.info.phone, i.accounts[0].account, i.accounts[0].globalBankName].join(' '),

        title: 'CÔNG NỢ CỦA KHO THÁNG ' + period,
        columns: [
          {
            title: 'Nhà cung cấp',
            html: function (i) {
              return '<b>' + i.info.name + '</b><br><small>' + i.info.address + '</small>';
            },
          },
          {
            title: 'Liên hệ',
            html: i => {
              let html = '';

              html += i.info.phone != '' ? '<div class="text-primary"><i class="fa-phone fa"></i>' + i.info.phone + '</div>' : '';
              html += i.info.email != '' ? '<div class="text-primary"><i class="fa fa-envelope"></i>' + i.info.email + '</div>' : '';

              i.accounts.forEach(account => {

                let validation = this.banking.validate(account);
                html += '<div class="' + (validation.valid ? (validation.transferable ? 'text-success' : '') : 'text-danger') + '"><sub><i class="' + (validation.valid ? (validation.transferable ? 'fa fa-bank' : 'fas fa-dollar-sign') : 'fa fa-exclamation-circle') + '"></i>' + (validation.valid ? account.globalBankName + ' (' + account.name + ')' : (account.name == '' ? 'Lỗi tài khoản phụ chưa đặt tên' : 'Lỗi ' + account.name)) + '</sub></div>';
              });

              return html;
            },
            css: i => 'custom-info text-uppercase',
            click: i => this.edit(i)
          },
          {
            title: 'Tổng công nợ',
            class: 'text-right',
            html: i => i.debt > 0 ? '<b>' + this.decimal.transform(i.debt, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>' : '0',
            css: i => 'text-right text-danger',
            click: i => {
              i.debt > 0 ? this.viewDebts(i.info) : ''
            }
          },
          {
            title: 'Đã tạm ứng',
            class: 'text-right',
            html: i => '<b>' + this.decimal.transform(i.deposits, '1.0-0', 'en-US') + '</b><br><small class="text-danger"><i>Ghi nhận tạm ứng</i></small>',
            css: i => 'text-right text-success',
            click: i => this.pay(i)
          }

        ],

        footer: data => {
          let debts = 0;
          let deposits = 0;

          data.forEach(i => {
            debts += i.debt;
            deposits += i.deposits;
          });
          return [
            { html: '<b>TỔNG</b>' },
            { html: '' },
            {
              html: '<b>' + this.decimal.transform(debts, '1.0-0', 'en-US') + '</b>',
              class: 'text-right text-danger'
            },
            {
              html: '<b>' + this.decimal.transform(deposits, '1.0-0', 'en-US') + '</b>',
              class: 'text-right text-success'
            }

          ];
        }
      }
    }
    /* ============================================ */
    return {
      data: data,

      group: i => {

        let parts = i.info.address.split(',');

        if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

        return { parent: "TẤT CẢ CỬA HÀNG", html: parts[parts.length - 1].trim() }
      },

      txt: i => [i.info.name, i.info.address, i.accounts[0].owner, i.info.phone, i.accounts[0].account, i.accounts[0].globalBankName].join(' '),

      title: 'CÔNG NỢ CỦA KHO THÁNG ' + period,
      columns: [
        {
          title: 'Nhà cung cấp',
          html: function (i) {
            return '<b>' + i.info.name + '</b><br><small>' + i.info.address + '</small>';
          },
        },
        {
          title: 'Liên hệ',
          html: i => {
            let html = '';

            html += i.info.phone != '' ? '<div class="text-primary"><i class="fa-phone fa"></i>' + i.info.phone + '</div>' : '';
            html += i.info.email != '' ? '<div class="text-primary"><i class="fa fa-envelope"></i>' + i.info.email + '</div>' : '';

            i.accounts.forEach(account => {

              let validation = this.banking.validate(account);
              html += '<div class="' + (validation.valid ? (validation.transferable ? 'text-success' : '') : 'text-danger') + '"><sub><i class="' + (validation.valid ? (validation.transferable ? 'fa fa-bank' : 'fas fa-dollar-sign') : 'fa fa-exclamation-circle') + '"></i>' + (validation.valid ? account.globalBankName + ' (' + account.name + ')' : (account.name == '' ? 'Lỗi tài khoản phụ chưa đặt tên' : 'Lỗi ' + account.name)) + '</sub></div>';
            });

            return html;
          },
          css: i => 'custom-info text-uppercase',
          click: i => this.edit(i)
        },
        {
          title: 'Đã tạm ứng',
          class: 'text-right',
          html: i => i.deposits == 0 ? '0' : '<b>' + this.decimal.transform(i.deposits, '1.0-0', 'en-US') + '</b><br><i class="text-primary"><small>Chi tiết</small></i>',
          css: i => 'text-right',
          visible: this.period == this.currentPeriod,
          click: i => {
            if (i.deposits > 0) this.viewDeposits(i);
          }
        },
        {
          title: 'Tổng công nợ',
          class: 'text-right',
          // html: i => '<b>' + this.decimal.transform(i.Debt, '1.0-0', 'en-US'),
          html: i => '<b>' + this.decimal.transform(i.debt, '1.0-0', 'en-US') + '</b>' + '<br>' + '<i class="text-primary"><small>Chi tiết</small></i>',
          css: i => 'text-right text-danger',
          click: i => this.viewDebts(i.info)
        },
        {
          title: 'Đã trả',
          class: 'text-right',
          html: i => '<b>' + this.decimal.transform(i.returned, '1.0-0', 'en-US') + '</b>',
          css: i => 'text-right text-success'
        },
        {
          title: 'Cần trả',
          class: 'text-right',
          html: i => {
            let left = i.debt - i.returned;
            return Math.round(left) <= 0 ? '0' : '<b class="text-danger">' + this.decimal.transform(left, '1.0-0', 'en-US') + '</b><br><small class="text-danger"><i>' + (this.period != this.nextPeriod ? 'Ghi nhận chi' : 'Ghi nhận đặt cọc') + '</i></small>';
          },
          css: i => 'text-right',
          click: i => this.pay(i)
        },
        {
          title: 'Trả thừa',
          class: 'text-right',
          html: i => {
            let ovp = i.returned - i.debt;
            return Math.round(ovp) < 0 ? '0' : Math.round(ovp) > 10000 ? '<b class=" text-warning">' + this.decimal.transform(ovp, '1.0-0', 'en-US') + '</b>' : this.decimal.transform(ovp, '1.0-0', 'en-US');
          },
          css: i => 'text-right',
        }
      ],

      footer: data => {
        let debts = 0;
        let returned = 0;
        let DTR = 0;
        let RTD = 0;
        let deposits = 0;
        data.forEach(i => {
          debts += i.debt;
          returned += i.returned;
          DTR += i.debt - i.returned > 0 ? i.debt - i.returned : 0;
          RTD += i.returned - i.debt > 0 ? i.returned - i.debt : 0;
          deposits += i.deposits;
        });
        return [
          { html: '<b>TỔNG</b>' },
          { html: '' },
          {
            html: '<b>' + this.decimal.transform(deposits, '1.0-0', 'en-US') + '</b>',
            class: 'text-right',
            visible: this.period == this.currentPeriod
          },
          {
            html: '<b>' + this.decimal.transform(debts, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-danger'
          },
          {
            html: '<b>' + this.decimal.transform(returned, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-success'
          },
          {
            html: '<b>' + this.decimal.transform(DTR, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-danger'
          },
          {
            html: '<b>' + this.decimal.transform(RTD, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-warning'
          },
        ];
      }
    }
  }

  private async asyncMount() {

    let accounts = {};
    let history = {};

    await this.cache.get(this.VENDOR_SUB_ACCOUNTS_CACHE_KEY, {})
      .toPromise()
      .then(data => accounts = data);

    await this.cache.get(this.VENDOR_PAYMENT_HISTORY_CACHE_KEY, {})
      .toPromise()
      .then(data => history = data);


    return Promise.resolve({ accounts: accounts, history: history });
  }

  private async asyncLoad(period) {

    let data: Array<VOCDebtRecordDTO>;

    await this.api.debtToVendors(period)
      .toPromise()
      .then(response => data = response.succeed ? response.data : []);

    return Promise.resolve({ data: data });
  }

  private async asyncUpdate(data: Vendor) {

    let info, accounts;

    let request = {
      ID: data.info.id,
      Phone: data.info.phone,
      Email: data.info.email,
      Mode: data.info.type,
      Account: data.accounts[0].account,
      Name: data.accounts[0].owner,
      Bank: data.accounts[0].globalBankName,
      Branch: data.accounts[0].globalBranchName
    };

    await this.api.updateVOC(request).toPromise().then(response => info = response.succeed && response.data);

    let key = '#' + data.info.id;

    let jsonObj = {};
    for (let o in this.subs) jsonObj[o] = this.subs[o];
    jsonObj[key] = data.accounts.filter(i => i != data.accounts[0]);

    await this.cache.set(this.VENDOR_SUB_ACCOUNTS_CACHE_KEY, jsonObj).toPromise().then(response => accounts = response);

    return Promise.resolve({ info: info, accounts: accounts });
  }

  ngOnInit() {

    let anchor = new Date();

    this.nextPeriod = this.date.transform(anchor, "MM-yyyy");

    anchor.setMonth(anchor.getMonth() - 1)

    this.currentPeriod = this.date.transform(anchor, "MM-yyyy");

    this.asyncMount()
      .then(rs => {

        this.history = rs.history;
        this.subs = rs.accounts;

        if (this.dtConfig != null) {
          this.dtConfig.data.forEach(i => {

            i.accounts = [i.accounts[0]];
            let key = "#" + i.info.id;

            if (typeof this.subs[key] != "undefined") this.subs[key].forEach(account => i.accounts.push(account));
          });
        }
      });
  }

  // load debts to vendors in a specified period
  load(period) {

    this.loading = true;

    this.asyncLoad(period)
      .then(rs => {

        this.loading = false;

        let data: Array<VendorDebtRecord> = [];

        rs.data.sort((a, b) => a.Debt - a.Returned > b.Debt - b.Returned ? -1 : 1).forEach(i => {

          let obj: VendorDebtRecord = {
            info: {
              id: i.ID,
              name: i.Name,
              address: i.Address,
              type: VOCType.vendor,
              phone: i.Phone,
              email: i.Email
            },

            accounts: [{
              name: 'THÔNG TIN CHÍNH',
              account: i.BankAccount,
              owner: i.Contact,
              globalBankName: i.BankName,
              globalBranchName: i.BankBranch
            }],

            debt: i.Debt,
            returned: i.Returned,
            deposits: i.Deposits
          };

          let key = '#' + obj.info.id;

          if (typeof this.subs[key] != 'undefined') this.subs[key].forEach(account => obj.accounts.push(account));

          data.push(obj);
        });

        this.period = period;
        this.dtConfig = this.generate(data, period);
      });
  }

  viewDeposits(record: VendorDebtRecord) {
    this.modal.show(DepositsEditorComponent, {
      class: 'modal-lg',
      initialState: {
        data: {
          vendorId: record.info.id,
          name: record.info.name,
          address: record.info.address,
          period: this.period,
          total: record.deposits
        }
      }
    }).content.closed.subscribe(changed => {
      if (changed) this.load(this.period);
    });
  }

  // view details of debts to a vendor
  viewDebts(vendor: VOC) {
    this.modal.show(DetailsViewerComponent, {
      class: 'modal-lg',
      initialState: {
        data: {
          vendor: vendor,
          period: this.period
        }
      }
    });
  }

  // acknowledge a payment to a vendor
  pay(record: VendorDebtRecord) {
    this.modalRef = this.modal.show(PaymentEditorComponent, {
      class: 'modal-md',
      initialState: {
        data: {
          shortName: 'NCC',
          name: record.info.name,
          address: record.info.address,
          type: PaymentEditorType.expense,
          accounts: this.banking.sources,
          account: typeof this.history["#" + record.info.id] == "undefined" ? null : this.history["#" + record.info.id],
          amount: this.period == this.nextPeriod ? 0 : Math.max(0, record.debt - record.returned)
        }
      }
    }).content.commit.subscribe(data => {

      if (typeof this.history["#" + record.info.id] == "undefined" || this.history["#" + record.info.id] != data.account) {
        this.history["#" + record.info.id] = data.account;

        this.cache.set(this.VENDOR_PAYMENT_HISTORY_CACHE_KEY, this.history).subscribe(succeed => { });
      }

      let request = {
        ID: record.info.id,
        Amount: data.amount,
        Bank: data.account,
        Period: this.period,
        Date: data.date
      };

      this.loading = true;

      this.api.payToVendor(request).subscribe(
        response => {

          this.loading = false;
          if (response.succeed && response.data) {

            if (this.period == this.nextPeriod) {
              record.deposits += data.amount;
            }
            else {
              record.returned += data.amount;
            }
          }
          else {
            this.error("Không tạo được " + (this.period == this.nextPeriod ? " tạm ứng" : " ghi nhận chi"));
          }

        },
        error => {
          this.loading = false;
          this.error("Không tạo được " + (this.period == this.nextPeriod ? " tạm ứng" : " ghi nhận chi"));
        }
      );
    });
  }

  error(message: string) {

    let data: MessageBoxData = {
      title: "LỖI",
      content: '<div class="text-danger text-center">' + message + '</div>',
      buttons: [{ name: "OK", class: "bg-danger" }],
      closable: true,
      header: true
    };

    this.modal.show(MessageBoxComponent, {
      class: 'modal-md', initialState: {
        data: data
      }
    });
  }

  // edit vendor information
  edit(vendor: VendorDebtRecord) {

    this.modal.show(VOCEditorComponent, {
      class: 'modal-lg',
      initialState: {
        data: {
          info: vendor.info,
          accounts: vendor.accounts,
        }
      }
    }).content.change
      .subscribe(data => {

        this.asyncUpdate(data).then(rs => {

          if (rs.info) vendor.info = data.info;
          if (rs.accounts) {
            vendor.accounts = data.accounts;

            let key = '#' + vendor.info.id;
            this.subs[key] = data.accounts.filter(account => account != data.accounts[0]);
          }
        });
      });
  }

  export() {
    this.modal.show(MassTransferEditorComponent, {
      class: 'modal-lgg',
      initialState: {
        data: {
          records: this.dtConfig.data,
          title: (this.period == this.nextPeriod ? 'TẠM ỨNG CHO NHÀ CUNG CẤP THEO LÔ THÁNG ' : 'THANH TOÁN CHO NHÀ CUNG CẤP THEO LÔ THÁNG ') + this.period,
          period: this.period,
          mode: this.period == this.nextPeriod ? 'select' : 'list'
        }
      }
    })
  }

  confirm() {
    this.modal.show(MassTransferResolverComponent, {
      class: 'modal-lgg',
    }).content.closed.subscribe(changed => {
      if (changed) this.load(this.period);
    });
  }
}
